let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ecsjw")).then(() => parcelRequire('d8mSz'));